import { useRef, useState } from 'react';

/**
 * Debounced server-side search backing an Autocomplete — reuses the overview pages' queries.
 * `pending` is true from the first keystroke until the search completes, so the field can show
 * "Søker …" during both the debounce delay and the request itself.
 */
export function useDebouncedSearch(runSearch: (term: string) => Promise<unknown>) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [pending, setPending] = useState(false);
  const onInput = (term: string) => {
    if (timer.current) clearTimeout(timer.current);
    if (term.trim().length < 2) {
      setPending(false);
      return;
    }
    setPending(true);
    timer.current = setTimeout(() => {
      void runSearch(term.trim()).finally(() => setPending(false));
    }, 300);
  };
  return { onInput, pending };
}
